import { useEffect } from 'react';

/**
 * Injects a noindex/nofollow directive for the onboarding form page.
 * This page should not be crawled or indexed by search engines.
 */
export default function OnboardingSeo() {
  useEffect(() => {
    const ROBOTS_ID = 'onboarding-robots-meta';
    let el = document.getElementById(ROBOTS_ID) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement('meta');
      el.id = ROBOTS_ID;
      el.name = 'robots';
      document.head.appendChild(el);
    }
    el.content = 'noindex, nofollow';

    const CANONICAL_ID = 'onboarding-canonical';
    const existing = document.getElementById(CANONICAL_ID);
    if (existing) existing.remove();

    return () => {
      const robotsMeta = document.getElementById(ROBOTS_ID);
      if (robotsMeta) {
        (robotsMeta as HTMLMetaElement).content = 'index, follow';
      }
    };
  }, []);

  return null;
}
